import axios from 'axios';
import baseConfig from '../config/index.js';
import Vue from 'vue';
import store from '../vuex/store.js';

axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
// 添加请求拦截器
axios.interceptors.request.use(config => {
  // 访问权限控制
  if (!config.isNoPermission) {
    let { permissions } = store.state.user.userInfo;
    permissions = permissions.filter(v => v.perType !== 'menu').map(v => v.perUrl);
    if (permissions.indexOf('/' + config.url) === -1) {
      /* eslint-disable */
      return Promise.reject({msg: '无权限访问~'+config.url});
    }
  }
  // console.table({
  //   msg: config.url + ' -> api允许访问',
  //   query: JSON.stringify(config.params),
  //   data: JSON.stringify(config.data)
  // });
  if (!config.isCustomUrl) { // 是否是自定义域名 否则取默认配置项
    config.url = baseConfig.apiPath + config.url;
  }
  // 在发送请求之前做些什么
  config.headers['access-token'] = store.state.user.userInfo.token || '';
  config.headers['author-token'] = localStorage.getItem('authortoken') || '';
  if (!config.isJson) {
    config.transformRequest = [data => {
      // 对 data 进行任意转换处理
      let format = new FormData(), temp = '';
      for (const key in data) {
        temp = typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key];
        if ([undefined, null].includes(data[key]) === false) {
          format.append(key, temp);
        }
      }
      return format;
    }];
  } else { // json
    config.headers['Content-Type'] = 'application/json';
    config.transformRequest = [data => {
      // 对 data 进行任意转换处理
      return JSON.stringify(data);
    }];
  }
  return config;
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(response => {
  if(response.config.responseType === 'arraybuffer'){
    return response.data;
  }
  // 对响应数据做点什么
  if (response.data.code === '000') { // 请求正常
    if (response.data.token) {
      store.dispatch('user/updateUser', {
        token: response.data.token
      });
    }
    // 返回所有的数据 包括 msg code data...
    if (response.config.isAllData === true) {
      return response.data || {};
    }
    // 只返回 data
    return response.data.data || {};
  }
  if(response.data.code === '004'){ //token值無效
    alert('当前账号已在其他地方登录 ')
    window.location.href = '../login.html'
  }
  /* if(response.data.code === '999'){ //token值無效
    alert('当前账号已在其他地方登录 ')
    window.location.href = '../login.html'
  }*/
  return Promise.reject(response.data);
}, error => {
  // 对响应错误做点什么
  return Promise.reject(error);
});

const Http = (params = {}) => {
  const _ajax = arg => {
    return axios(Object.assign(params, arg));
  };
  return {
    // 返回一个 post请求 promise
    post: () => _ajax({method: 'post'}),
    // 返回一个 get请求 promise
    get: () => _ajax({method: 'get'}),
    // 返回一个 get请求 promise
    put: () => _ajax({method: 'put'}),
    // 返回一个 get请求 promise
    delete: () => _ajax({method: 'delete'})
  };
};

Vue.prototype.$http = axios;
Vue.prototype.$config = baseConfig;

export const $http = Http;



// WEBPACK FOOTER //
// ./src/utils/http.js